/** Jarvis Knowledge — pack settings: name, description, on/off, who can see it. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Switch } from '../ui/switch';
import { btnGhost, btnPrimary, errorText, inputCls } from '../finance/financeUi';
import { ROLES } from './PackList';

export function PackEditor({ pack, onChange }) {
  const [f, setF] = useState(pack);
  useEffect(() => setF(pack), [pack]);
  const patch = async (body, msg) => {
    try { onChange(await api.request(`/jarvis/packs/${pack.pack_id}`, { method: 'PATCH', body: JSON.stringify(body) })); toast.success(msg); } catch (e) { toast.error(errorText(e)); }
  };
  const toggleRole = (r) => patch({ allowed_roles: f.allowed_roles.includes(r) ? f.allowed_roles.filter((x) => x !== r) : [...f.allowed_roles, r] }, 'Visibility updated');
  const retire = async () => {
    if (!window.confirm(`Remove "${pack.name}"? Jarvis stops using it immediately.`)) return;
    try { await api.request(`/jarvis/packs/${pack.pack_id}`, { method: 'DELETE' }); onChange(null); toast.success('Pack removed'); } catch (e) { toast.error(errorText(e)); }
  };
  return (
    <div className="space-y-3 px-5 py-4" data-testid="jarvis-pack-editor">
      <div className="flex flex-wrap items-center gap-2">
        <input className={`${inputCls} max-w-xs`} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="jarvis-pack-name" />
        <input className={`${inputCls} max-w-md`} placeholder="Short description" value={f.description || ''} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="jarvis-pack-description" />
        <button type="button" className={btnPrimary} onClick={() => patch({ name: f.name, description: f.description }, 'Pack saved')} data-testid="jarvis-pack-save-btn">Save</button>
        <label className="ml-auto flex items-center gap-2 text-sm">
          <Switch checked={pack.enabled} onCheckedChange={(v) => patch({ enabled: v }, v ? 'Pack turned on' : 'Pack turned off — Jarvis stops using it')} data-testid="jarvis-pack-enabled" />
          {pack.enabled ? 'On' : 'Off'}
        </label>
        <button type="button" className={btnGhost} onClick={retire} data-testid="jarvis-pack-remove-btn">Remove</button>
      </div>
      <div className="flex flex-wrap items-center gap-4 text-sm" data-testid="jarvis-pack-roles">
        <span className="text-xs text-muted-foreground">Who can see it (Super Admin always can):</span>
        {ROLES.map(([r, label]) => (
          <label key={r} className="flex items-center gap-1.5">
            <input type="checkbox" checked={pack.allowed_roles.includes(r)} onChange={() => toggleRole(r)} data-testid={`jarvis-role-${r}`} />{label}
          </label>
        ))}
      </div>
    </div>
  );
}
